function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.3125C0 0.587626 0.587626 0 1.3125 0H22.6875C23.4124 0 24 0.587626 24 1.3125V22.6875C24 23.4124 23.4124 24 22.6875 24H1.3125C0.587626 24 0 23.4124 0 22.6875V1.3125Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.1518 20.1552C15.3347 20.1552 17.9149 17.5749 17.9149 14.3921C17.9149 11.2092 15.3347 8.62894 12.1518 8.62894C8.96894 8.62894 6.38871 11.2092 6.38871 14.3921C6.38871 17.5749 8.96894 20.1552 12.1518 20.1552ZM12.1518 21.7529C16.2171 21.7529 19.5126 18.4573 19.5126 14.3921C19.5126 10.3268 16.2171 7.03125 12.1518 7.03125C8.08656 7.03125 4.79102 10.3268 4.79102 14.3921C4.79102 18.4573 8.08656 21.7529 12.1518 21.7529Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0936 18.6724C14.4886 18.6724 16.4302 16.7308 16.4302 14.3358C16.4302 11.9407 14.4886 9.99918 12.0936 9.99918C9.69855 9.99918 7.75699 11.9407 7.75699 14.3358C7.75699 16.7308 9.69855 18.6724 12.0936 18.6724ZM12.0936 19.3571C14.8668 19.3571 17.1149 17.109 17.1149 14.3358C17.1149 11.5626 14.8668 9.31445 12.0936 9.31445C9.32039 9.31445 7.07227 11.5626 7.07227 14.3358C7.07227 17.109 9.32039 19.3571 12.0936 19.3571Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.7514 14.0499V10.8545H12.6644V14.9629H9.69727V14.0499H11.7514Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.875 3.82467L4.58278 6.44945L4.3125 4.87478L19.6047 2.25L19.875 3.82467Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.4554 4.61496C11.4867 4.48209 11.5129 4.37119 11.5261 4.28516L13.1052 4.52792C13.0752 4.72329 13.0333 4.91408 12.9913 5.10512C12.8329 5.82662 12.6737 6.55178 13.1497 7.54078L11.71 8.23368C10.9668 6.68941 11.2865 5.3321 11.4554 4.61496Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6918 4.52068C13.6918 5.34004 13.0275 6.00426 12.2082 6.00426C11.3888 6.00426 10.7246 5.34004 10.7246 4.52068C10.7246 3.70133 11.3888 3.03711 12.2082 3.03711C13.0275 3.03711 13.6918 3.70133 13.6918 4.52068Z",
  fill: "white"
});

function SvgDuration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.2fd61866.svg";
export { ForwardRef as ReactComponent };